import moment from "moment-mini";
import {ActionCreatorDefinition, createAction} from "redux-ts";
import {PortfolioType} from "enum/PortfolioType";
import {FilterDateType} from "core/redux/filter/FilterReduxState";
import {RouteType} from "core/router/Routes";
import {Continent} from "enum/Continent";
import {QuoteStatus} from "platform/protocol/enum/QuoteStatus";

export const SetFilterVisibleType: string =  "SetFilterVisible";
export const SetPortfolioDateFilterType: string =  "SetPortfolioDateFilter";
export const UpdatePortfolioDateFilterType: string =  "UpdatePortfolioDateFilter";
export const ResetFilterType: string =  "ResetFilter";
export const SetSymbolFilterContinentType: string = "SetSymbolFilterContinent";
export const SetMarketsStatusType: string = "SetMarketsStatusType";
export const SetClosedTradesDefaultFilterType: string = "SetClosedTradesDefaultFilter";

export interface SetFilterVisiblePayload {

    visible: boolean;
    route?: RouteType;
    activePortfolioTab?: PortfolioType;
}

export interface PortfolioDateFilterPayload {

    portfolioType: PortfolioType;
    dateType: FilterDateType;
    from: moment.Moment;
    to: moment.Moment;
}

export interface ResetFilterPayload {

    route: RouteType;
    activePortfolioTab: PortfolioType;
    activeSymbolsCategory: string;
}

export interface SetSymbolFilterContinentPayload {

    continents: Continent[];
}

export interface SetMarketsStatusPayload {

    marketStatus: QuoteStatus;
}

export interface SetClosedTradesDefaultFilterPayload {

    dateType: FilterDateType;
}

export const SetFilterVisible: ActionCreatorDefinition<SetFilterVisiblePayload, any> = createAction<SetFilterVisiblePayload>(SetFilterVisibleType);
export const SetPortfolioDateFilter: ActionCreatorDefinition<PortfolioDateFilterPayload, any> = createAction<PortfolioDateFilterPayload>(SetPortfolioDateFilterType);
export const UpdatePortfolioDateFilter: ActionCreatorDefinition<PortfolioDateFilterPayload, any> = createAction<PortfolioDateFilterPayload>(UpdatePortfolioDateFilterType);
export const ResetFilter: ActionCreatorDefinition<ResetFilterPayload, any> = createAction<ResetFilterPayload>(ResetFilterType);
export const SetSymbolFilterContinent: ActionCreatorDefinition<SetSymbolFilterContinentPayload, any> = createAction<SetSymbolFilterContinentPayload>(SetSymbolFilterContinentType);
export const SetMarketsStatus: ActionCreatorDefinition<SetMarketsStatusPayload, any> = createAction<SetMarketsStatusPayload>(SetMarketsStatusType);
export const SetClosedTradesDefaultFilter: ActionCreatorDefinition<SetClosedTradesDefaultFilterPayload, any> = createAction<SetClosedTradesDefaultFilterPayload>(SetClosedTradesDefaultFilterType);
